<template>
    <div class="w-100 h-100 tracker-widget position-relative">
        <div
            class="bg-white h-100 p-2 d-flex flex-column justify-content-start"
            style="background-color:#cdcdcd; border-radius: 0 0 6px 6px;"
        >
            <div class="d-flex justify-content-between align-center">
                <div class="mr-2">
                    <toggle-button
                        :value="!!active"
                        color="#D64571"
                        @change="$emit('toggle', $event)"
                        :sync="true"
                        :labels="true"
                    />
                </div>
                <p class="mb-2 mr-auto text-capitalize">
                    {{
                        type
                            .replace("_", " ")
                            .replace("soap", "SOAP")
                            .replace("cme", "CME (Estimated Second Record Number)")
                            .replace("analysis", "analysis (Step-by-step)")
                            .replace("mand echoic", "echoic")
                    }}
                </p>
            </div>
            <div class="mb-3">
                <small class="description">
                    <div class="px-2" style="line-height: 1.5;" v-html="description"></div>
                </small>
            </div>
            <hr
                style="width:100%;margin: 0 auto;color:#c3c3c3;background: #c3c3c3; height: 1px; margin-bottom:0.5rem;"
            />
            <slot name="customizations"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrackerCustomize",
    props: ["active", "type", "description"],
    data() {
        return {};
    },
    created() {},
    methods: {},

    computed: {},
};
</script>

<style scoped lang="scss">
.description {
    line-height: 1.2;
}
</style>
